import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ServiceAreasServiceType} from "../../angular/types/service-areas-service.type";

export class ServiceAreaSelectCtrl implements IController {

  selectedId: any;
  branchIds: string[];
  options: any[];
  optionIds: string[];
  name: string;
  serviceTypes: ServiceAreasServiceType[];
  isRequired: boolean;
  isDisabled: boolean;
  excludeIds: string[];
  ngPlaceholder: string;
  form: any;
  onChange: Function;


  private serviceAreasRef: any;
  public selectedServiceArea: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private $serviceArea) {
    this.serviceAreasRef = this.$serviceArea();
  }

  $onInit() {

    if (!this.name) {
      this.name = 'serviceAreaSelect';
    }

    this._setSelected();
  };

  $postLink() {
    this.setValidity();
  }

  $onChanges(changes) {
    if ((changes.selectedId && !changes.selectedId.isFirstChange()) ||
      (changes.options && !changes.options.isFirstChange()) ||
      (changes.optionIds && !changes.optionIds.isFirstChange()) ||
      (changes.branchIds && !changes.branchIds.isFirstChange())) {
      this._setSelected();
      this.setValidity();
    }
  };

  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdRef = this.selectedId;
    const branchIdsRef = this.branchIds;
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const excludeIdsRef = this.excludeIds;
    const serviceTypesRef = this.serviceTypes;
    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdsRef" ' +
        'branch-ids="ctrl.branchIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'service-areas-types="ctrl.serviceTypesRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'serviceArea';
        this.selectedIdsRef = selectedIdRef;
        this.branchIdsRef = branchIdsRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.excludeIdsRef = excludeIdsRef;
        this.serviceTypesRef = serviceTypesRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId) => {
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          selectedId = selectedIdRef;
        }

        if (!selectedId) {
          this.onChange({serviceArea: undefined, id: undefined});
          panel.destroy();
        } else {
          if (!!this.options) {
            const serviceArea = _.find(this.options, (o) => {
              return o.id === selectedId;
            })
            this.onChange({serviceArea: serviceArea, id: selectedId});
            panel.destroy();
          } else {
            this.serviceAreasRef.$asyncValues([selectedId])
              .then((serviceAreas) => {
                this.onChange({serviceArea: serviceAreas[0], id: selectedId});
                panel.destroy();
              });
          }
        }
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({serviceArea: undefined});
  }

  private _setSelected() {
    if (!!this.selectedId) {
      if (!!this.options) {
        this.selectedServiceArea = _.find(this.options, (o) => {
          return o.id === this.selectedId;
        });
        this._setSelectedText();
      } else {
        this.serviceAreasRef.$asyncValues([this.selectedId])
          .then((serviceAreas) => {
            this.selectedServiceArea = _.orderBy(serviceAreas, ['areaName'], ['asc'])[0];
            this._setSelectedText()
          });
      }
    } else {
      this.selectedServiceArea = undefined;
      this._setSelectedText()
    }
  }

  private _setSelectedText() {
    this.selectedText = _.get(this.selectedServiceArea, 'name') ||
      _.get(this.selectedServiceArea, 'areaName', '');
  }

  setValidity() {
    if (!this.selectedId) {
      this.form[this.name].$setValidity('isValid', true);
    } else {
      const optionsIds = this.optionIds || _.map(this.options, 'areaId');
      this.form[this.name].$setValidity('isValid', !!optionsIds?.length ? !!_.includes(optionsIds, this.selectedId) : true);
    }
  }

}

angular
  .module('bringoz.admin.service-areas')
  .component('serviceAreaSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedId: '<',
      branchIds: '<?',
      options: '<?',
      optionIds: '<?',
      name: '<?',
      serviceTypes: '<?',
      isRequired: '<?',
      isDisabled: '<?',
      excludeIds: '<?',
      ngPlaceholder: '@?',
      onChange: '&',
    },
    template: require('./service-area-select.html').default,
    controller: ServiceAreaSelectCtrl
  });
